export var timeseriesOptions = function timeseriesOptions(theme) {
  return {
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    chart: {
      backgroundColor: theme.chartsBackgroundColor,
      height: '640px'
    },
    yAxis: {
      opposite: false,
      showFirstLabel: false,
      lineColor: theme.chartsAxisColor,
      labels: {
        align: 'right'
      }
    },
    xAxis: {
      type: 'datetime',
      lineColor: theme.chartsAxisColor
    },
    scrollbar: {
      enabled: false
    },
    navigator: {
      enabled: false
    },
    series: [],
    legend: {
      enabled: false
    },
    rangeSelector: {
      floating: false,
      buttonTheme: {
        fill: 'none',
        height: 20,
        width: 64,
        states: {
          hover: {
            fill: '#aaa'
          },
          select: {
            fill: '#eee'
          }
        },
        style: {
          fontSize: 14
        }
      },
      selected_: 1,
      inputEnabled: false,
      buttons: [{
        type: 'ytd',
        count: 1,
        text: 'YTD'
      }, {
        type: 'year',
        count: 1,
        text: '1A'
      }, {
        type: 'year',
        count: 3,
        text: '3A'
      }, {
        type: 'year',
        count: 5,
        text: '5A'
      }, {
        type: 'year',
        count: 10,
        text: '10A'
      }]
    },
    title: {
      text: ''
    },
    plotOptions: {
      series: {
        pointInterval: 24 * 3600 * 1000
      }
    }
  };
};